var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v("Нет такой страницы!")]),_c('p',[_vm._v("Перейти "),_c('router-link',{staticClass:"link",attrs:{"to":{ name: 'News' }}},[_vm._v("в новости?")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }